import component from './PhNote.vue_vue&type=script&lang.js';
export { default } from './PhNote.vue_vue&type=script&lang.js';
import { render } from './PhNote.vue_vue&type=template&id=81e3f09a&lang.js';

component.render = render;
